
export class DadosIntegracao {
    constructor(
        public nomeIntegrador: string = '',
        public cnpjIntegrador: string = '',
        public credencialCliente: string = ''
    ) {}
}